import React, { useState, useEffect } from 'react';

// تحويل رابط الفيديو لـ embed مع تشغيل تلقائي (Vimeo / YouTube / ملف Drive)
const getEmbed = (url) => {
  if (!url) return null;
  const vimeo = url.match(/vimeo\.com\/(?:reviews\/[^/]+\/videos\/|video\/|)(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1&muted=1&title=0&byline=0&portrait=0`;
  const yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?autoplay=1&mute=1&rel=0&playsinline=1`;
  const df = url.match(/drive\.google\.com\/file\/d\/([^/]+)/);
  if (df) return `https://drive.google.com/file/d/${df[1]}/preview`;
  const dopen = url.match(/drive\.google\.com\/open\?id=([^&]+)/);
  if (dopen) return `https://drive.google.com/file/d/${dopen[1]}/preview`;
  return null; // فولدر Drive أو رابط غير مدعوم
};

const SEEN_KEY = 'gw_intro_seen_v1';

export default function IntroVideo({ settings, lang }) {
  const enabled = settings?.intro_enabled;
  const embed   = getEmbed(settings?.intro_video_url);
  const title   = settings?.intro_title;
  const ar      = lang !== 'en';

  const [show,    setShow]    = useState(false);
  const [visible, setVisible] = useState(false);

  // يظهر مرة واحدة في الجلسة لما العميل يفتح الموقع
  useEffect(() => {
    if (!enabled || !embed) return;
    let seen = false;
    try { seen = sessionStorage.getItem(SEEN_KEY) === '1'; } catch {}
    if (!seen) {
      setShow(true);
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch {}
    }
  }, [enabled, embed]);

  // دخول ناعم بعد التركيب
  useEffect(() => {
    if (!show) return;
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, [show]);

  if (!show || !embed) return null;

  const close = () => { setVisible(false); setTimeout(() => setShow(false), 380); };

  return (
    <div onClick={close}
      style={{
        position: 'fixed', inset: 0, zIndex: 5000,
        background: 'radial-gradient(circle at 50% 38%, rgba(15,22,64,0.96), rgba(3,6,20,0.99))',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: '24px', backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
        opacity: visible ? 1 : 0, transition: 'opacity .4s ease',
        fontFamily: "'Tajawal', sans-serif", direction: ar ? 'rtl' : 'ltr',
        overflow: 'hidden',
      }}>
      {/* كور مضيئة في الخلفية */}
      <div style={{ position: 'absolute', top: '-120px', insetInlineEnd: '-120px', width: '360px', height: '360px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(249,115,22,0.35), transparent 70%)', filter: 'blur(40px)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: '-140px', insetInlineStart: '-120px', width: '380px', height: '380px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(99,102,241,0.3), transparent 70%)', filter: 'blur(44px)', pointerEvents: 'none' }} />

      {/* زر إغلاق */}
      <button onClick={close}
        style={{ position: 'absolute', top: '18px', insetInlineEnd: '18px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)', color: '#fff', width: '40px', height: '40px', borderRadius: '10px', fontSize: '18px', cursor: 'pointer', zIndex: 2 }}>✕</button>

      {/* العنوان */}
      {title && (
        <h2 style={{
          color: '#fff', fontSize: 'clamp(22px,4vw,38px)', fontWeight: '900', margin: '0 0 18px',
          textAlign: 'center', letterSpacing: '0.5px',
          transform: visible ? 'translateY(0)' : 'translateY(14px)', transition: 'transform .55s cubic-bezier(.22,1,.36,1)',
          textShadow: '0 6px 30px rgba(249,115,22,0.4)',
        }}>
          <span style={{ background: 'linear-gradient(135deg,#fff,#fdba74)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>✨ {title}</span>
        </h2>
      )}

      {/* إطار الفيديو بتوهّج برتقالي */}
      <div onClick={e => e.stopPropagation()}
        style={{
          position: 'relative', width: '100%', maxWidth: '900px',
          transform: visible ? 'scale(1)' : 'scale(0.96)', transition: 'transform .55s cubic-bezier(.22,1,.36,1)',
        }}>
        <div style={{
          position: 'relative', paddingBottom: '56.25%', borderRadius: '18px', overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.12)',
          boxShadow: '0 0 0 1px rgba(249,115,22,0.45), 0 0 60px rgba(249,115,22,0.28), 0 40px 100px rgba(0,0,0,0.65)',
        }}>
          <iframe title="intro" src={embed}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }}
            allow="autoplay; fullscreen; encrypted-media; picture-in-picture" allowFullScreen />
        </div>
      </div>

      {/* زر الدخول */}
      <button onClick={close}
        style={{
          marginTop: '24px', padding: '13px 38px',
          background: 'linear-gradient(135deg,#f97316,#fb923c)', color: '#fff', border: 'none',
          borderRadius: '12px', fontSize: '15px', fontWeight: '800', cursor: 'pointer',
          boxShadow: '0 14px 34px rgba(249,115,22,0.45)', fontFamily: "'Tajawal', sans-serif",
          transform: visible ? 'translateY(0)' : 'translateY(14px)', transition: 'transform .6s cubic-bezier(.22,1,.36,1), filter .2s',
        }}
        onMouseEnter={e => e.currentTarget.style.filter = 'brightness(1.08)'}
        onMouseLeave={e => e.currentTarget.style.filter = 'none'}>
        {ar ? 'دخول الموقع ←' : 'Enter Site →'}
      </button>

      <p style={{ marginTop: '12px', color: 'rgba(255,255,255,0.5)', fontSize: '12px' }}>
        {ar ? 'اضغط في أي مكان للتخطّي' : 'Click anywhere to skip'}
      </p>
    </div>
  );
}
